















import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";

const axios = require('axios');

@Component({
    name: "PublicAnnouncement",
    computed: {
        ...mapGetters({
            profile: 'profile', user: 'user'
        })
    },
})
export default class PublicAnnouncement extends Vue {
    @Prop(String) readonly announcementUuid!: string;
    @Prop(String) readonly companyUuid!: string;
    private announcement: any = {}

    private mounted() {
        let url = 'https://us-central1-jobtojob-c9b04.cloudfunctions.net/announcements/public/'
            + this.companyUuid + '/' + this.announcementUuid + '/';

        axios.get(url).then((res: any) => {
            this.announcement = res.data;
        })
    }

    private openAnnouncement() {
        this.$router.push({
            name: 'Announcement', params: {
                companyUuid: this.companyUuid, announcementUuid: this.announcementUuid
            }
        })
    }

}

